module.exports = __webpack_public_path__ + "static/media/stadium_3.f33971d9.jpg";